export default __webpack_public_path__ + "static/media/upload_icon.c6791322.svg";